import { render, staticRenderFns } from "./PagePerformanceReviewSettings.vue?vue&type=template&id=1d9e067d&scoped=true&"
import script from "./PagePerformanceReviewSettings.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReviewSettings.vue?vue&type=script&lang=js&"
import style0 from "./PagePerformanceReviewSettings.vue?vue&type=style&index=0&id=1d9e067d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9e067d",
  null
  
)

export default component.exports